jQuery(document).ready(function ($) {
    var iframe = document.getElementById('vitavideo');

// $f == Froogaloop
    var player = $f(iframe);

    $('.video-cont .button').on('click', function () {
        console.log('click')
        $(this).parent().addClass('hide');
        player.api("play");
        $('.section-video .text').css('top', '100%');
    });

    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    function addAnims() {
        if ($('.main-left').hasClass('replaced-svg')) {
            $('.main-left').find('.floating').each(function () {
                var random = getRandomInt(1, 4);
                var thisItem = $(this);

                setTimeout(function(){ thisItem.addClass('group' + random); }, 399);
            });
        } else {
            setTimeout(function(){ addAnims(); }, 100);
        }
    }
    function addAnims2() {
        if ($('.main-right').hasClass('replaced-svg')) {
            $('.main-right').find('.floating').each(function () {
                var random = getRandomInt(1, 4);
                var thisItem = $(this);

                setTimeout(function(){ thisItem.addClass('group' + random); }, 399);
            });
        } else {
            setTimeout(function(){ addAnims2(); }, 100);
        }
    }

    addAnims();
    addAnims2();

    $('#page-vitafruit').on('scroll', function(){
        if ($(window).width() > 1200) {
            var scrollTop = $('#page-vitafruit').scrollTop();
            var g1px = scrollTop / 40;
            var g2px = -scrollTop / 30;
            var g3px = scrollTop / 20;
            var g4px = -scrollTop / 10;

            var splashpx = -scrollTop / 25;


            $('body').find('.group1').css('transform', 'translateY(' + g1px + 'px)');
            $('body').find('.group2').css('transform', 'translateY(' + g2px + 'px)');
            $('body').find('.group3').css('transform', 'translateY(' + g3px + 'px)');
            $('body').find('.group4').css('transform', 'translateY(' + g4px + 'px)');

            $('.splash-bg').css('transform', 'translateY(' + splashpx + 'px)');
        }
    });



    $('.section-hero').waypoint(function(direction) {
        this.element.classList.add('animating');
    }, {
        context: '#page-vitafruit',
        offset: '75%'
    });
    $('.section-hero-active').waypoint(function(direction) {
        this.element.classList.add('animating');
    }, {
        context: '#page-active',
        offset: '75%'
    });
    $('.section-products').waypoint(function(direction) {
        this.element.classList.add('animating');
    }, {
        context: '#page-vitafruit',
        offset: '75%'
    });
    $('.section-products').waypoint(function(direction) {
        this.element.classList.add('animating');
    }, {
        context: '#page-active',
        offset: '75%'
    });
    $('.section-gifs').waypoint(function(direction) {
        this.element.classList.add('animating');
    }, {
        context: '#page-active',
        offset: '75%'
    });
    $('.section-video').waypoint(function(direction) {
        this.element.classList.add('animating');
    }, {
        context: '#page-vitafruit',
        offset: '75%'
    });
});